<template>
    <div class="legenda-item">
        <div class="grid-container" :class="{'withCell': !withoutCell}">
            <slot></slot>
        </div>
    </div>
    <div class="legenda-description">{{ description }}</div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class LegendItem extends Vue {
        @Prop({type: String, required: true}) public description!: string;
        @Prop({type: Boolean}) public isHeader!: boolean;
        @Prop({type: Boolean}) public withoutCell!: boolean;
    }
</script>

<style lang="scss" scoped>
    .legenda-item,
    .legenda-description {
        border-bottom: solid 1px var(--deployment-marker-border-top-color);
        padding: 0.75rem 0.25rem;
    }

    .legenda-item {
        padding-left: 0;
    }

    .legenda-description {
        padding-right: 0;

        span {
            font-style: italic;
        }
    }

    .grid-container {
        border: 1px solid var(--cell-border-color);

        &.withCell {
            border-bottom: none;
            border-right: none;
        }

        &:not(.withCell) {
            padding: 0.3rem;
        }
    }
</style>
